import React from 'react';

const URL_REGEX = /(https?:\/\/[^\s<]+)/g;

interface LinkifyProps {
  children: string;
}

export const Linkify: React.FC<LinkifyProps> = ({ children }) => {
  const parts = children.split(URL_REGEX);

  return (
    <>
      {parts.map((part, i) =>
        URL_REGEX.test(part) ? (
          <a
            key={i}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="linkified"
            onClick={(e) => e.stopPropagation()}
          >
            {part}
          </a>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      )}
    </>
  );
};
